import {createSelector} from 'reselect';

import MessageType from '../../../enums/MessageType';
import Translation from '../../lang/Translation';

const makeGetPaymentOptionDisabledMessage = (
  getIsPaymentDisabledByDelivery,
  getIsOptionDisabledByOrderSummaryPaymentOptions,
  paymentType,
  getPaymentSpecificMessage = () => null,
) => createSelector(
  [getIsPaymentDisabledByDelivery, getIsOptionDisabledByOrderSummaryPaymentOptions, getPaymentSpecificMessage],
  (isDisabledByDelivery, isDisabledByOrderSummaryPaymentOptions,
    paymentSpecificMessage) => {
    if (isDisabledByOrderSummaryPaymentOptions) {
      return {
        type: MessageType.INFO,
        embeddedValues: [Translation.getText(paymentType)],
        translationKey: 'error.payment.option.disabled.by.order.summary',
      };
    }
    if (isDisabledByDelivery) {
      return {
        type: MessageType.INFO,
        embeddedValues: [Translation.getText(paymentType)],
        translationKey: 'error.payment.option.disabled.by.delivery.option',
      };
    }
    return paymentSpecificMessage;
  },
);

export default makeGetPaymentOptionDisabledMessage;
